"use client";

import { useState, useEffect } from "react";
import Image, { ImageProps } from "next/image";

interface SafeImageProps extends Omit<ImageProps, "src" | "alt"> {
  src: string;
  alt: string;
  fallback?: string;
}

export default function SafeImage({
  src,
  alt,
  fallback = "/assets/card-texture.webp",
  ...props
}: SafeImageProps) {
  const [imgSrc, setImgSrc] = useState(src);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setImgSrc(src);
    setHasError(false);

    // Test if image exists
    const testImg = new window.Image();
    testImg.onerror = () => {
      setHasError(true);
      setImgSrc(fallback);
    };
    testImg.onload = () => {
      setHasError(false);
      setImgSrc(src);
    };
    testImg.src = src;
  }, [src, fallback]);

  return <Image {...props} src={hasError ? fallback : imgSrc} alt={alt} />;
}
